import * as jsxRuntime from "/home/runner/work/theseus-client-web/theseus-client-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment